var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0063 9.44675L1.58843 9.44675C1.28971 9.44675 1.04736 9.15761 1.04736 8.80055C1.04736 8.44349 1.28971 8.15435 1.58843 8.15435L14.0063 8.15405C14.305 8.15405 14.5474 8.44319 14.5474 8.80025C14.5476 9.15761 14.305 9.44675 14.0063 9.44675Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3641 14.0582C10.1955 14.0582 10.0275 13.9927 9.90096 13.8625C9.65179 13.6064 9.6578 13.1977 9.91358 12.9485L14.2038 8.77466L9.88742 4.06397C9.64577 3.80068 9.6638 3.39192 9.92709 3.15089C10.1898 2.91044 10.6 2.92728 10.8402 3.19086L15.5803 8.36405C15.8168 8.62164 15.8048 9.02017 15.5544 9.26359L10.8146 13.8751C10.6892 13.9974 10.5263 14.0581 10.364 14.0581L10.3641 14.0582Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationRight);
export default __webpack_public_path__ + "static/media/navigation-right.b0499f81dd504ef9b4113c228e799d2f.svg";
export { ForwardRef as ReactComponent };